import axios, { CancelTokenStatic, CancelTokenSource } from "axios";
import storageService from "../utils/local-storage.utils";
const Config = process.env.REACT_APP_BASE_URL;
export class HttpService {
  CancelToken: CancelTokenStatic;
  source: CancelTokenSource;

  constructor() {
    this.CancelToken = axios.CancelToken;
    this.source = this.CancelToken.source();
    axios.interceptors.response.use(undefined, function (error) {
      if (error?.response?.status == 401) {
        storageService.removeItem('token');
        localStorage.removeItem('persist:root');
        window.location.reload();
      }
      return Promise.reject(error);
    })
  }

  /**
   * Set Token On Header
   * @param token
   */
  static setToken(token: string): void {
    axios.defaults!.headers!["Authorization"] = `Bearer ${token}`;
  }

  /**
   * Fetch data from server
   * @param url Endpoint link
   * @return Promise
   */
  protected get = async (url: string, params?: any, headers?: Record<string, string>): Promise<any> => {
    const res = await axios.get(`${Config}/${url}`, {
      params,
      headers,
      cancelToken: this.source.token,
    });
    return res.data;
  }

  /**
   * Write data over server
   * @param url Endpoint link
   * @param body Data to send over server
   * @return Promise
   */
  protected post = async (url: string, body: any, options = {}, headers?: Record<string, string>): Promise<any> => {
    const res = await axios.post(`${Config}/${url}`, body, {
      ...options,
      headers,
      cancelToken: this.source.token,
    });
    return res.data;
  }


  /**
   * Delete Data From Server
   * @param url Endpoint link
   * @param params Embed as query params
   * @return Promise
   */
  protected delete = async (url: string, params?: any, data?: any): Promise<any> => {
    const res = await axios.delete(`${Config}/${url}`, { params, data });
    return res.data;
  }

  /**
   * Update data on server
   * @param url Endpoint link
   * @param body Data to send over server
   * @param params Embed as query params
   * @return Promise
   */
  protected put = async (url: string, body?: any, params?: any): Promise<any> => {
    const res = await axios.put(`${Config}/${url}`, body, {
      ...params,
      cancelToken: this.source.token,
    });
    return res.data;
  }

  private updateCancelToken() {
    this.source = this.CancelToken.source();
  }

  cancel = () => {
    this.source.cancel("Explicitly cancelled HTTP request");
    this.updateCancelToken();
  };
}
